/* Keep Grid's existing variant selectors as the source of truth. */
(function () {
  function syncPicker(picker) {
    var select = picker.querySelector('select[data-option-select]');
    if (!select) return;
    var radios = picker.querySelectorAll('.product-radio-picker__input');
    for (var i = 0; i < radios.length; i++) {
      var option = Array.prototype.find.call(select.options, function (item) {
        return item.value === radios[i].value;
      });
      radios[i].disabled = !option || option.disabled;
      radios[i].checked = select.value === radios[i].value;
    }
  }

  function syncAll(root) {
    var pickers = root.querySelectorAll('[data-radio-picker]');
    for (var i = 0; i < pickers.length; i++) syncPicker(pickers[i]);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target.matches('.product-radio-picker__input')) {
      var picker = target.closest('[data-radio-picker]');
      var select = picker && picker.querySelector('select[data-option-select]');
      if (select && !target.disabled) {
        select.value = target.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        syncAll(picker.closest('[data-product-form]') || document);
      }
    } else if (target.matches('.product-radio-picker select[data-option-select]')) {
      syncAll(target.closest('[data-product-form]') || document);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncAll(document);
    document.documentElement.classList.add('product-radio-picker-ready');
  });
  document.addEventListener('shopify:section:load', function (event) {
    syncAll(event.target);
  });
}());
